module.exports = __webpack_public_path__ + "img/oaFlowData195@3x.e09dcb54.png";